<template>
    <div>
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold  text-white">My Profile</h1>
                            <h4 class="font-weight-light  text-white">MANAGE MY INFO</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="boxes-hero">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-12 my-2">
                        <div class="box shadow-lg bg-white rounded">
                            <div style="padding: 30px; font-size: 18px">
                                <form @submit.prevent="saveUser">
                                    <table v-if="user" width="100%" cellpadding="10px" cellspacing="10px">
                                        <tr>
                                            <td width="45%">
                                                <b-form-group label="First name" label-align-sm="left">
                                                    <b-form-input
                                                            id="save-user-first-name"
                                                            v-model="user.first_name" type="text"
                                                    />
                                                </b-form-group>
                                            </td>
                                            <td width="45%">
                                                <b-form-group label="Last name" label-align-sm="left">
                                                    <b-form-input
                                                            id="save-user-last-name"
                                                            v-model="user.last_name" type="text"
                                                    />
                                                </b-form-group>
                                            </td>
                                            <td width="5%">&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <b-form-group label="Mobile number" label-align-sm="left">
                                                    <b-form-input
                                                            id="save-user-mobile"
                                                            v-model="user.mobile_number"
                                                            type="text"
                                                    />
                                                </b-form-group>
                                            </td>
                                            <td>
                                                <b-form-group label="Time Zone" label-align-sm="left">
                                                    <b-form-select
                                                            v-model="user.time_zone"
                                                            :options="timezones"
                                                    />
                                                </b-form-group>
                                            </td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td valign="top">
                                                <b-form-group label="Email" label-align-sm="left">
                                                    <b-form-input
                                                            id="save-user-email"
                                                            v-model="user.email"
                                                            type="email"
                                                            :disabled="!updateEmail"
                                                    />
                                                </b-form-group>
                                            </td>
                                            <td>
                                                <b-form-group label="Password" label-align-sm="left">
                                                    <b-form-input
                                                            id="save-user-password"
                                                            v-model="user.password"
                                                            type="password"
                                                            placeholder="●●●●●●●●"
                                                            :disabled="!updateEmail"
                                                    />
                                                </b-form-group>
                                                <br/>
                                                <b-form-group label="Retype Password" label-align-sm="left">
                                                    <b-form-input
                                                            id="password-confirm"
                                                            v-model="password_confirmation"
                                                            type="password"
                                                            :disabled="!updateEmail"
                                                    />
                                                </b-form-group>
                                            </td>
                                            <td valign="top">
                                                <span v-on:click="updateEmail = !updateEmail" style="margin-top:35px; color: #296a9b" class="icon-blue mx-1"><img src="/icons/icon-edit.png" height="15"></span>
                                            </td>
                                        </tr>
                                    </table>
                                    <div class="text-right">
                                        <b-btn id="save-user-submit" type="submit" variant="dark">
                                            Save
                                        </b-btn>
                                        &nbsp;
                                        <b-btn id="save-user-cancel" to="/">
                                            Cancel
                                        </b-btn>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

        import { getAlertTimezones } from '../networking/alerts'
        import { admin_methods } from '../networking/account'
        import usersApi from '../user_apis'

        export default {
            name: 'Profile',
            props: {
                userData: {
                    type: Object,
                    required: true
                }
            },

            data() {
                return {
                    updatePassword: false,
                    updateEmail: false,
                    user: {},
                    password_confirmation: null,
                    timezones: []
                }
            },

            async created(){
                this.loadUser()
                const { value: { data }} = await getAlertTimezones()
                this.timezones = data
            },

            methods: {
                async loadUser() {
                    const user = await usersApi.getUser(this.userData.userId)
                    this.user = user.data
                },
                async saveUser() {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' })

                    const generator = admin_methods.edit_user(this.user)
                    const { value: { data, alert }} = await generator.next()

                    this.userData.firstName = this.user.first_name
                    this.userData.lastName = this.user.last_name
                    this.userData.email = this.user.email
                    this.updateEmail = false
                    this.$emit(
                        'showAlert',
                        alert.message,
                        alert.variant,
                        alert.variant === 'success' ? 1800 : 5000
                    )
                }
            }
        }
</script>

<style scoped>
    .btn-secondary {
        color: #fff !important;
        background-color: black;
    }

</style>